import { render, staticRenderFns } from "./UploadFileForLearning.vue?vue&type=template&id=4274cc32"
import script from "./UploadFileForLearning.vue?vue&type=script&lang=js"
export * from "./UploadFileForLearning.vue?vue&type=script&lang=js"
import style0 from "./UploadFileForLearning.vue?vue&type=style&index=0&id=4274cc32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports